import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "../ui-helpers";

export function LoginPage({ onLogin }: { onLogin: (password: string) => Promise<unknown> }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  return (
    <div className="grid min-h-screen place-items-center bg-background p-6">
      <div className="grid w-full max-w-sm gap-4">
        <h1 className="text-xl font-semibold">citybrews admin</h1>
        <form className="grid gap-3" onSubmit={(event) => {
          event.preventDefault();
          setBusy(true);
          onLogin(password).catch((error) => toast.error(error instanceof Error ? error.message : "Login failed")).finally(() => setBusy(false));
        }}>
          <Field label="Password"><Input autoFocus type="password" value={password} onChange={(event) => setPassword(event.target.value)} /></Field>
          <Button type="submit" disabled={busy}>{busy && <Loader2 className="animate-spin" />} Continue</Button>
        </form>
      </div>
    </div>
  );
}
